var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurePayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_51668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0802 91.1752H26.8322C45.6357 91.1752 64.4258 91.1886 83.2293 91.1484C84.5266 91.1484 85.1016 91.5635 85.65 92.7151C93.701 109.426 106.446 121.143 123.605 128.026C129.65 130.449 135.735 130.101 141.726 127.571C155.22 121.893 166.026 113.002 174.01 100.696C174.198 100.401 174.425 100.12 174.84 99.5309C174.893 100.348 174.947 100.803 174.947 101.258C174.947 116.965 174.987 132.686 174.947 148.393C174.906 162.038 165.892 172.576 152.438 174.745C151.048 174.973 149.617 174.986 148.199 174.986C116.049 174.986 83.898 175.013 51.7609 174.986C38.0127 174.986 27.4474 165.988 25.2541 152.463C25.0535 151.231 25.0267 149.959 25.0267 148.714C25 130.061 25 111.395 25 92.7419C25 92.3134 25.0401 91.8715 25.0802 91.1752ZM78.9631 147.08C85.8773 147.08 92.7915 147.094 99.7191 147.08C102.875 147.08 105.229 144.764 105.202 141.805C105.176 138.912 102.849 136.622 99.7994 136.622C85.9709 136.596 72.1291 136.596 58.3006 136.649C57.2709 136.649 56.1341 137.024 55.2514 137.56C53.2587 138.752 52.4697 141.108 53.1116 143.251C53.7937 145.541 55.7463 147.067 58.2204 147.08C65.1346 147.107 72.0489 147.08 78.9765 147.08H78.9631ZM65.1346 115.653C62.9012 115.653 60.6812 115.64 58.4478 115.653C55.2782 115.68 52.911 117.903 52.8843 120.835C52.8575 123.781 55.2113 126.084 58.3541 126.111C62.8611 126.138 67.3814 126.151 71.8884 126.111C74.9242 126.084 77.2646 123.794 77.3047 120.929C77.3315 118.023 74.9376 115.693 71.8215 115.653C69.5881 115.626 67.368 115.653 65.1346 115.653Z",
    fill: "url(#paint0_linear_117_51668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.946 55.3695C175.12 62.9619 175.013 70.5543 172.887 77.9324C167.404 97.0272 155.434 110.391 137.192 118.131C133.729 119.604 130.171 119.537 126.707 118.023C105.363 108.664 92.6979 92.4611 89.7289 69.3224C88.6457 60.8864 89.3277 52.2227 89.2341 43.6528C89.2341 43.2243 89.3545 42.7958 89.4481 42.3674C90.6383 36.904 93.9149 33.1949 99.2912 31.896C109.442 29.4456 119.646 27.1558 129.904 25.1874C132.552 24.6785 135.521 25.3882 138.262 25.9506C146.795 27.7048 155.287 29.633 163.779 31.5479C171.108 33.2083 175.067 38.3368 174.973 45.8757C174.933 49.0358 174.973 52.2093 174.973 55.3695H174.946ZM130.064 69.5232C128.499 67.7691 127.122 66.0015 125.517 64.475C123.458 62.5334 120.168 62.7744 118.295 64.7696C116.45 66.738 116.383 69.9249 118.295 71.9067C121.024 74.7187 123.819 77.4905 126.681 80.1686C129.034 82.3781 131.936 82.2843 134.277 80.0481C135.775 78.6153 137.232 77.1424 138.704 75.6828C142.341 72.0808 146.006 68.4922 149.617 64.8499C151.221 63.2297 151.569 60.8998 150.62 58.9581C149.59 56.8558 147.611 55.6373 145.27 56.0926C144.08 56.3336 142.823 57.0433 141.927 57.8869C138.048 61.5425 134.29 65.332 130.078 69.483L130.064 69.5232Z",
    fill: "url(#paint1_linear_117_51668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7358 52.785C78.5887 62.2387 78.4549 71.4647 81.1965 80.5703H25.0936C24.7593 76.379 25.3745 72.3619 27.1265 68.6126C31.834 58.5563 39.7914 53.1198 50.905 52.8252C59.6782 52.5976 68.4513 52.7716 77.2245 52.7716C77.6525 52.7716 78.0805 52.7716 78.7358 52.7716V52.785Z",
    fill: "url(#paint2_linear_117_51668)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_51668",
    x1: 99.9822,
    y1: 91.1484,
    x2: 99.9822,
    y2: 174.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_117_51668",
    x1: 132.055,
    y1: 25.0127,
    x2: 132.055,
    y2: 119.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_117_51668",
    x1: 53.1014,
    y1: 52.708,
    x2: 53.1014,
    y2: 80.5703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_51668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePayment);
export default __webpack_public_path__ + "static/media/Secure_Payment.50bbc82d289700f17c81e263bb82aafe.svg";
export { ForwardRef as ReactComponent };